export const environment = {
    production: false,
    hmr: false,
    gqlUrl: 'https://gqlbeta.spekwo.com/graphql',
    website: 'http://beta.spekwo.com/',
    displayWebsite: 'beta.spekwo.com',
    email: 'hello@spekwo.com',
    apiHost: 'https://beta.api.spekwo.com/',
    apiHostDisplay: 'beta.api.spekwo.com',
    customerUrl: 'https://beta.client.spekwo.com/',
    displayCusUrl: 'beta.client.spekwo.com',
    wpCouponSite: 'https://beta.spekwo.com/wp-admin/edit.php?post_type=shop_coupon',
    picStories: 'https://beta.api.spekwo.com/PictureStories/',
    ownerRoleId: '8dab2f2a-2866-4527-9b3d-d2237d8d24c7',
    executiveRoleId: "fe66b505-c5dd-46a4-94ed-acb1fabbfaab",
    apiHostDev: 'https://dev.api.spekwo.com/',
};



// WEBPACK FOOTER //
// /vercel/path0/src/environments/environment.ts